import { type ReactElement } from "react";
import { useLanguage } from "@/context";
import { t } from "@/data";

export const NotFound = (): ReactElement => {
  const { lang } = useLanguage();

  return (
    <div id="notFound">
      <div className="container">
        <h1>404</h1>
        <h2>{t(lang, "notFoundTitle")}</h2>
        <p>{t(lang, "notFoundText")}</p>
      </div>
    </div>
  );
};
